'use client';

import FadeInSection from '$components/FadeInSection/FadeInSection';
import { SplitTextMulti } from '$components/SplitTextMulti/SplitTextMulti';
import { TimelineItem } from '$components/Timeline/TimelineItem';
import cn from 'classnames';
import { HTMLAttributes } from 'react';

import { ITimeline } from './';
import { TimeLineContextProvider } from './context';

export function Timeline(props: ITimeline & HTMLAttributes<HTMLElement>) {
  const { content, title } = props;

  return (
    <TimeLineContextProvider>
      <div>
        {title && (
          <h1 className="style-heading-s text-center mb-12 lg:mb-16 moveText">
            <SplitTextMulti
              copy={title}
              role="heading"
              speed={25}
              delay={1.0}
            />
          </h1>
        )}
        <FadeInSection className={cn('overflow-hidden')}>
          <div className="flex flex-row justify-center ">
            <div className={`grid-standard `}>
              <div className={` col-span-4 lg:col-span-12 lg:my-0 my-6`}>
                {content.map((item, index) => {
                  return (
                    <FadeInSection key={index}>
                      <TimelineItem
                        length={content.length}
                        item={item}
                        index={index}
                      />
                    </FadeInSection>
                  );
                })}
              </div>
            </div>
          </div>
        </FadeInSection>
      </div>
    </TimeLineContextProvider>
  );
}
